<template>
  <div class="notice-toast-item">
    <div class="toast-header">
      <span class="toast-title">{{ title }}</span>
      <i class="el-icon-close toast-close" @click="$emit('close')" />
    </div>
    <div class="toast-body">
      <template v-if="isOrder">
        <new-order-notice
          v-if="noticeType === 3"
          :payload="payload"
          @later="$emit('later', $event)"
          @view-order="$emit('view-order')"
        />
        <order-reject-notice
          v-else-if="noticeType === 4"
          :payload="payload"
          @copy-order="$emit('copy-order')"
          @read="$emit('read')"
        />
        <pass-order-notice
          v-else-if="noticeType === 5"
          :payload="payload"
          @view-order="$emit('view-order')"
          @read="$emit('read')"
        />
        <order-cancel-notice
          v-else-if="noticeType === 6"
          :payload="payload"
          @later="$emit('later')"
          @view-order="$emit('view-order')"
        />
      </template>
      <div v-else class="generic-notice">
        <div class="generic-row">
          <span class="generic-label">消息类型</span>
          <span class="generic-value">{{ typeText }}</span>
        </div>
        <div class="generic-row">
          <span class="generic-label">标题</span>
          <span class="generic-value">{{ message.title || '—' }}</span>
        </div>
        <div class="generic-row">
          <span class="generic-label">内容</span>
          <span class="generic-value">{{ message.content || '—' }}</span>
        </div>
        <div class="generic-row">
          <span class="generic-label">时间</span>
          <span class="generic-value">{{ message.createTime || '—' }}</span>
        </div>
        <div class="generic-actions">
          <el-button size="small" @click="$emit('close')">关闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewOrderNotice from '@/components/orderNotice/NewOrderNotice.vue'
import OrderRejectNotice from '@/components/orderNotice/OrderRejectNotice.vue'
import PassOrderNotice from '@/components/orderNotice/PassOrderNotice.vue'
import OrderCancelNotice from '@/components/orderNotice/OrderCancelNotice.vue'
import {
  getNoticeTitle,
  getNoticeTypeText,
  isOrderNotice,
  parseOrderNoticePayload
} from '@/utils/noticeHelper'

export default {
  name: 'NoticeToastItem',
  components: {
    NewOrderNotice,
    OrderRejectNotice,
    PassOrderNotice,
    OrderCancelNotice
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    noticeType() {
      return Number(this.message && this.message.noticeType)
    },
    payload() {
      return parseOrderNoticePayload(this.message)
    },
    isOrder() {
      return isOrderNotice(this.message)
    },
    title() {
      return getNoticeTitle(this.message)
    },
    typeText() {
      return getNoticeTypeText(this.noticeType)
    }
  }
}
</script>

<style scoped>
.notice-toast-item {
  width: 380px;
  max-width: calc(100vw - 48px);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(31, 35, 41, 0.14);
  border: 1px solid #eef0f3;
  pointer-events: auto;
  overflow: hidden;
}
.toast-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 12px;
  border-bottom: 1px solid #eef0f3;
}
.toast-title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
  line-height: 1.4;
  padding-right: 8px;
}
.toast-close {
  font-size: 16px;
  color: #8f959e;
  cursor: pointer;
  flex-shrink: 0;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s, background 0.2s;
}
.toast-close:hover {
  color: #1f2329;
  background: #f2f3f5;
}
.toast-body {
  padding: 12px 16px 16px;
  max-height: min(70vh, 520px);
  overflow-y: auto;
}
.toast-body >>> .order-notice {
  padding: 0;
}
.toast-body >>> .hero-icon {
  width: 44px;
  height: 44px;
  font-size: 22px;
  margin-bottom: 10px;
}
.toast-body >>> .hero-title {
  font-size: 16px;
}
.generic-notice {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.generic-row {
  display: grid;
  grid-template-columns: 4.5em 1fr;
  gap: 8px;
  align-items: start;
  font-size: 13px;
  line-height: 1.5;
}
.generic-label {
  color: #8f959e;
  font-weight: 500;
  text-align: right;
}
.generic-value {
  color: #1f2329;
  word-break: break-word;
}
.generic-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}
</style>
